// var set_penalty = function(el, index_str, working_index) {
//   if (index_str != null) {
//     set_ticket_violation_mgr(el);
//     var calculate = ticket_violation_mgr.calculate_penalty();
//     var diff = null;
//     var actual_speed = jQuery("#actual_speed_" + index_str).val();
//     var posted_limit =  jQuery("#posted_limit_" + index_str).val();
//     if (actual_speed != undefined && posted_limit != undefined && actual_speed.length > 0 && posted_limit.length > 0) {
//       actual_speed = parseFloat(actual_speed);
//       posted_limit =  parseFloat(posted_limit);
//       diff = (actual_speed - posted_limit);
//     }
//     var points = ticket_violation_mgr.points();
//     var waiver = ticket_violation_mgr.waiver();
//     var min_penalty = ticket_violation_mgr.min_penalty();
//     var max_penalty = ticket_violation_mgr.max_penalty();
//     var penalty = waiver;
//     penalty = parseFloat(penalty);
//     if (diff != null) {
//       penalty = (waiver * diff) * 1.15 + min_penalty;
//     }
//     if (max_penalty > 0 && penalty > max_penalty) {
//       penalty = max_penalty;
//     }
//     penalty = Math.ceil(additional_penalties(penalty, working_index));
//     if (calculate == undefined && calculate != null && penalty > 0) {
//       jQuery("#penalty_" + index_str).val('');
//     } else {
//       jQuery("#penalty_" + index_str).val(penalty);
//     }
//   }
// };

// var additional_penalties = function(penalty, index) {
//   //if (additional_checked('hazmat', index)) { penalty += 115;}
//   if (additional_checked('cv_hazard_fee', index)) { penalty += 115;}
//   penalty += seatbelt_selection(index);
//   return penalty;
// };

const getWeightInThousands = weightLimit => {
  if (!weightLimit?.name) {
    return 0;
  }

  const match = weightLimit.name.match(/to ([\d,]+)/);
  if (!match) {
    return 0;
  }

  const weightInPounds = Number(match[1].replace(/,/g, ""));
  return weightInPounds / 1000;
};

const mapViolationOccurrence = violationOccurrence => {
  const name = violationOccurrence?.name;
  if (!name) {
    return 0;
  }

  const nameKey = name.split(" ")[0];
  const nameToValueMap = {
    First: 0,
    Second: 0.05,
    Third: 0.1,
    Fourth: 0.15,
  };

  return nameToValueMap[nameKey] || 0;
};

const calculateWeightPenalty = ({
  weightLimit,
  violationOccurrence,
  violationName,
  cvHazardFee,
  seatBeltOccurrence,
  includeFifteenPercent = true,
  includeSurcharge = true,
} = {}) => {
  if (!violationName) {
    return 0;
  }
  const poundsOver = getWeightInThousands(weightLimit) || 0;
  const doubleRate = violationName.includes("+99K");
  let costPerK;

  if (poundsOver === 0) {
    costPerK = 0;
  } else if (poundsOver <= 5) {
    costPerK = 15;
  } else if (poundsOver <= 10) {
    costPerK = 30;
  } else if (poundsOver <= 15) {
    costPerK = 45;
  } else if (poundsOver <= 20) {
    costPerK = 60;
  } else if (poundsOver <= 25) {
    costPerK = 90;
  } else {
    costPerK = 150;
  }

  if (doubleRate) {
    costPerK *= 2;
  }

  const base = poundsOver * costPerK;
  const fifteenPercentCharge = includeFifteenPercent
    ? Math.ceil(base * 0.15)
    : 0;
  const subTotal = base + fifteenPercentCharge;
  const occurrencePercent = mapViolationOccurrence(violationOccurrence) || 0;
  const occurrenceCharge = Math.ceil(subTotal * occurrencePercent) || 0;
  const surcharge = includeSurcharge ? 47 : 0;
  let penalty = subTotal + occurrenceCharge + surcharge;

  if (cvHazardFee) {
    penalty += 115;
  }

  if (seatBeltOccurrence) {
    if (seatBeltOccurrence === "First") {
      penalty += 25;
    } else if (seatBeltOccurrence === "Second") {
      penalty += 50;
    } else if (seatBeltOccurrence === "Third") {
      penalty += 100;
    } else {
      penalty += 0;
    }
  }

  penalty = Math.ceil(penalty);
  if (isNaN(penalty)) return undefined;
  return penalty;
};

const calculateBasePenalty = (
  actualSpeed,
  postedLimit,
  waiver,
  penaltyMin,
  penaltyMax,
  cvHazardFee,
  seatBeltOccurrence,
  isWarning,
  isSpeedingVio
) => {
  let diff = null;
  let penalty = waiver;

  if (isWarning) {
    return penalty;
  }

  if (actualSpeed && postedLimit && isSpeedingVio) {
    diff = actualSpeed - postedLimit;
  }
  if (diff !== null) {
    penalty = waiver * diff * 1.15 + penaltyMin;
  }
  if (penaltyMax && penaltyMax > 0 && penalty > penaltyMax) {
    penalty = penaltyMax;
  }
  // if(penaltyMin && penaltyMin > 0 && penalty < penaltyMin){
  //   penalty = penaltyMin
  // }
  if (cvHazardFee) {
    penalty += 115;
  }

  if (seatBeltOccurrence) {
    if (seatBeltOccurrence === "First") {
      penalty += 25;
    } else if (seatBeltOccurrence === "Second") {
      penalty += 50;
    } else if (seatBeltOccurrence === "Third") {
      penalty += 100;
    } else {
      penalty += 0;
    }
  }

  penalty = Math.ceil(penalty);
  if (isNaN(penalty)) return undefined;
  return penalty;
};

export const calculatePenalty = (
  actualSpeed,
  postedLimit,
  waiver,
  points,
  penaltyMin,
  penaltyMax,
  cvHazardFee,
  seatBeltOccurrence,
  isWarning = false,
  isSpeedingVio = true,
  weightContext = null
) => {
  const basePenalty = calculateBasePenalty(
    actualSpeed,
    postedLimit,
    waiver,
    penaltyMin,
    penaltyMax,
    cvHazardFee,
    seatBeltOccurrence,
    isWarning,
    isSpeedingVio
  );

  if (!weightContext?.isWeightViolation) {
    return basePenalty;
  }

  const weightPenalty = calculateWeightPenalty({
    ...weightContext,
    cvHazardFee,
    seatBeltOccurrence,
  });
  if (weightPenalty === 0 || weightPenalty === undefined) {
    return basePenalty;
  }
  return weightPenalty;
};
